// jQuery shim for esbuild to ensure jQuery UI can find jQuery
import jquery from 'jquery'
window.$ = window.jQuery = jquery
export { jquery as default }
